<template>
  <div>
    <b-modal :active="active" @close="active=false" style="overflow:hidden">
      <!-- <div class="card">
      <div class="card-header">
        <div class="card-header-title"></div>
      </div>

      <div class="card-content">-->
      <div style="overflow:hidden" class="box" id="temperatureHistogram"></div>
      <!-- </div> -->
      <!-- </div> -->
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      data: [],
      active: false
    };
  },
  async created() {},
  async mounted() {
    this.$root.$on("show_graph", () => {
      this.active = true;
      setTimeout(async () => {
          // this.getData();
    let { data } = await axios.get(
      "https://sensehawk-demo-data.s3.ap-south-1.amazonaws.com/stc.json"
    );
    this.data = data;
    this.SET_TEMP_DATA(this.data);
    this.getData();
      }, 100);
    });

  },
  methods: {
    ...mapMutations(["SET_TEMP_DATA"]),
    getData() {
      var trace1 = {
        x: this.data.map(s => s.sno),
        y: this.data.map(s => s.temperature),
        mode: "markers",
        type: "scatter",
        name: "Temperature",
        // text: ["A-1", "A-2", "A-3", "A-4", "A-5"],
        marker: { size: 9 }
      };
      var trace2 = {
        x: this.data.map(s => s.sno),
        y: this.data.map(s => s.stc_temperature),
        mode: "markers",
        type: "scatter",
        name: "STC Temperature",
        // text: ["B-a", "B-b", "B-c", "B-d", "B-e"],
        marker: { size: 9 }
      };
      var data = [trace1, trace2];
      var layout = {
        autosize: true,
        height: 480,
        // width: 900,
        // xaxis: {
        //   range: [0.75, 5.25]
        // },
        // yaxis: {
        //   range: [0, 8]
        // },
        title: "Observed vs STC Adjusted"
      };

      Plotly.newPlot("temperatureHistogram", data, layout);
    }
  }
};
</script>

<style>
</style>